// 1. Third-party plugins and files
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

// 2. Components
import Spinner from "../../components/spinner/Spinner";

// 6. Services
import { logout } from "../../services/IndiaService";
import { getStorageItemLocal } from "../../services/storageServices";

// 9. Config
import { appConfig } from "../../config/appConfig";

// 13. Styles
import "../indiaPdf/IndiaPdf.scss";

// AssetComponents

type AdminEntry = {
  [x: string]: any;
  id: number;
  name: string;
  uploadBy: string;
  urlName: string;
};

const IndiaLink = () => {
  // useStates
  const [dataList, setDataList] = useState<AdminEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const rowsPerPage = 39;

  // useNavigate
  const navigate = useNavigate();

  // useEffect
  useEffect(() => {
    fetchData();
  }, []);

  // Methods
  //   const fetchData = async () => {
  //     try {
  //       const tokenString = getStorageItemLocal("token");
  //       const token = tokenString ? JSON.parse(tokenString) : null;
  //       const response = await fetch(appConfig.serviceUrls.getURLcontroller, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       if (response.status === 401) {
  //         logout(navigate);

  //         return;
  //       }

  //       if (!response.ok) throw new Error("Failed to fetch data");
  //       const data: AdminEntry[] = await response.json();
  //       setDataList(data || []);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  const fetchData = async () => {
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;

      const response = await fetch(appConfig.serviceUrls.getURLcontroller, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        logout(navigate);
        return;
      }

      if (!response.ok) throw new Error("Failed to fetch data");

      const data: AdminEntry[] = await response.json();

      // ✅ Only take first 2 rows
      setDataList((data || []).slice(0, 1));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleupdate = async (index: number) => {
    if (!dataList || !Array.isArray(dataList) || dataList.length === 0) {
      console.error("Error: dataList is empty");
      return;
    }

    setLoading(true);

    const selectedEntry = dataList.find((item) => item.id === index);
    if (!selectedEntry) {
      console.error("No entry found for id:", index);
      return;
    }

    const username = getStorageItemLocal("username") ?? "";

    // ✅ Create FormData
    const formData = new FormData();

    formData.append("id", selectedEntry?.id?.toString() || "");
    formData.append("urlName", selectedEntry?.urlName || "");
    formData.append("lastUpdated", selectedEntry?.lastUpdated || "");
    formData.append("uploadBy", username);

    const url = `${appConfig.serviceUrls.getURLcontroller}/${index}`;

    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to save data");

      alert("Data saved successfully");
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Failed to save data");
    } finally {
      setLoading(false);
    }
  };

  //   const handleupdate = async (index: number) => {
  //     if (!dataList || !Array.isArray(dataList) || dataList.length === 0) {
  //       console.error("Error: dataList is empty");
  //       return;
  //     }
  //     setLoading(true);

  //     const selectedEntry = dataList.find((item) => item.id === index);
  //     if (!selectedEntry) {
  //       console.error("No entry found for id:", index);
  //       return;
  //     }
  //     const username = getStorageItemLocal("username") ?? "";
  //     const updatedEntry = {
  //       ...selectedEntry,

  //       UploadBy: username,
  //     };

  //     const updatedList = dataList.map((item) =>
  //       item.id === index ? updatedEntry : item,
  //     );
  //     console.log("Upadted List", updatedList);
  //     setDataList(updatedList);
  //     const url = `${appConfig.serviceUrls.getURLcontroller}/${index}`;

  //     try {
  //       const tokenString = getStorageItemLocal("token");
  //       const token = tokenString ? JSON.parse(tokenString) : null;
  //       const response = await fetch(url, {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify(updatedEntry),
  //       });

  //       if (!response.ok) throw new Error("Failed to save data");

  //       alert("Data saved successfully");
  //       fetchData(); // Refresh the data if needed
  //     } catch (error) {
  //       console.error("Error updating data:", error);
  //       alert("Failed to save data");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  const handletextupdate = (id: number, value: string) => {
    setDataList((prev: any[]) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              urlName: value, // 👈 update text here
            }
          : item,
      ),
    );
  };

  return (
    <Box className="container-wraper">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "5px",
        }}
      >
        <Typography className="bold-header-text">
          <b>India URL</b>{" "}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          marginBottom: 2,
        }}
      >
        {loading ? (
          <>
            {" "}
            <Spinner></Spinner>
          </>
        ) : (
          <TableContainer
            component={Paper}
            sx={{
              marginTop: 2,
              width: "100%",
            }}
          >
            {dataList?.length > 0 ? (
              <Table size="small">
                <TableHead>
                  <TableRow className="custom-table-head-row">
                    <TableCell>
                      <b>URL</b>
                    </TableCell>
                    <TableCell>
                      <b></b>
                    </TableCell>
                    <TableCell>
                      <b></b>
                    </TableCell>

                    <TableCell className="nowrap">
                      <b>Paste URL</b>
                    </TableCell>
                    <TableCell className="nowrap">
                      <b>Action</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                      <TableRow key={item.id}>
                        <TableCell>India-URL</TableCell>

                        <TableCell className="nowrap"></TableCell>
                        <TableCell className="nowrap"></TableCell>

                        <TableCell className="nowrap">
                          <Box className="pdf-name-wrapper1">
                            <TextField
                              placeholder="Enter URL"
                              size="small"
                              value={item.urlName || ""}
                              onChange={(e) =>
                                handletextupdate(item.id, e.target.value)
                              }
                              variant="standard"
                              fullWidth
                              InputProps={{ disableUnderline: true }}
                              inputProps={{ maxLength: 40 }}
                            />
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Button
                            onClick={() => handleupdate(item.id)}
                            size="small"
                            className="custom-button"
                          >
                            {" "}
                            <Typography className="btn-text">Update</Typography>
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            ) : (
              <Box sx={{ padding: "20px" }}>
                <Typography>No Data Found</Typography>
              </Box>
            )}
          </TableContainer>
        )}
      </Box>{" "}
    </Box>
  );
};

export default IndiaLink;
